export class StringHelper {
  /**
   * Replace all the ocurrences in the given string
   * by replace string
   * @param value String to replace
   * @param pattern Regex Pattern
   * @param replaceValue New value
   * @returns New string with values replaced
   */
  public static replaceAll(value: string, pattern: RegExp, replaceValue: string): string {
    const regex = new RegExp(pattern, "g");
    return value.replace(regex, replaceValue);
  }

  /**
   * Convert string to pascal case and replace hyphens by
   * spaces
   * @param value string to convert
   * @returns Given string in pascal case
   * @example value: ready-for-export -> Ready For Export
   */
  public static convertToHumanReadableText(value: string): string {
    const valueWithoutHyphens = StringHelper.replaceAll(value, /-/, " ");
    const regex = new RegExp(/(\w)(\w*)/g);

    return valueWithoutHyphens.replace(regex, function (group0, group1, group2) {
      return group1.toUpperCase() + group2.toLowerCase();
    });
  }

  /**
   * Capitalizes the first letter of a string
   * @param str The string
   * @returns The capitalized string
   */
  public static capitalizeFirstLetter(str: string): string {
    if (!str) {
      return str;
    }

    return str.charAt(0).toUpperCase() + str.slice(1);
  }
}
